import * as Yup from 'yup';

export const AddEditNote = Yup.object().shape({
  hasFollowUp: Yup.boolean().required(),
  customerId: Yup.number().required('Customer ID is required'),
  categoryId: Yup.string().required('Note Category is required'),
  content: Yup.string().test(
    'empty-check',
    'Note content can not be empty',
    content => content?.length > 0
  ),
  status: Yup.string().required('Note Status is required'),
  assignee: Yup.number().nullable(),
  contactedVia: Yup.string().nullable(),
  followupDate: Yup.string().when('hasFollowUp', {
    is: true,
    then: s => s.required('Followup Date is required'),
    otherwise: s => s.nullable()
  }),
  followupTime: Yup.number().when('hasFollowUp', {
    is: true,
    then: s => s.required('Followup Time is required'),
    otherwise: s => s.nullable()
  })
});
